import RsvpIcon from '@mui/icons-material/Rsvp';
import LoadingButton from '@mui/lab/LoadingButton';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import axios from 'axios';
import { createEvent } from "ics";
import moment from 'moment';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { store } from '..';
import * as ModalStore from '../store/Modal';
import i18n from '../i18n';
import { ApplicationState } from '../store';
import * as AppDataStore from '../store/AppData';
import Helpers from './helpers/Helpers';

function SearchBar(props: any) {
    const [name, setName] = React.useState('');
    const zoomMeetingData = useSelector((state: ApplicationState) => state?.appData?.meetingData);
    const userData = useSelector((state: ApplicationState) => state?.appData?.app4legalData);
    const [lookupData, setLookUpData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [loadButton, setLoadButton] = React.useState(false);
    const [checked, setChecked] = React.useState<any>([]);
    const [checkDefault, setCheckDefault] = React.useState<any>([]);
    const [itemsChecked, setItemsChecked] = React.useState(true);
    const [selectAll, setSelectAll] = React.useState(true);
    const [invitedEmails, setInvitedEmails] = React.useState("");
    const [emailBody, setEmailBody] = React.useState<string | null>(null);
    const [module, setModule] = React.useState(userData?.module);
    React.useEffect(() => {

        if (module) {
            let checkDefault: number[] = [];
            checkDefault = props.items !== null ? props.items?.map((item: any, index: number) => (item.id)) : [];
            setChecked(checkDefault);
            setCheckDefault(checkDefault);
            let emails = "";
            for (var i = 0; i < props?.items?.length; i++) {
                let result = checked?.find((element: number) => element == props.items[i].id);

                if (result || result === 0)
                    emails = emails + props.items[i].email + ",";
            }
            if (!props.invite) {
                props?.fillEmailsData(emails);
                props?.getEmails(emails, emailBody);
            }
        }
        else {
            // setItemsChecked(false);
        }
    }, [props.items]);

    React.useEffect(() => {
        if (zoomMeetingData) {
            let fullEmailBody = "\nTopic : " + zoomMeetingData.topic + "\n\n" + "Time:" + moment(zoomMeetingData?.start_time).format("MMM DD, YY") + "  " + zoomMeetingData?.timezone?.split("/")[0] + "\n\n" + zoomMeetingData?.join_url + "\n\n";
            setEmailBody(fullEmailBody)
        }
    }, [zoomMeetingData]);
    const add = () => {
        let checkDefault: number[] = [];
        checkDefault = props.items !== null ? props.items.map((item: any, index: number) => (item.id)) : [];
        setChecked(checkDefault);
        setCheckDefault(checkDefault);
    }
    const addNew = () => {
        let checkDefault: number[] = [];
        checkDefault = props.items !== null ? props.items.map((item: any, index: number) => (item.id)) : [];
        // setChecked(checkDefault);
        setCheckDefault(checkDefault);
    }
    // the search result
    const [foundUsers, setFoundUsers] = React.useState(props.items);

    const filter = (e: any) => {
        if (e.target.value.length > 2) {
            setLoading(true);
            const params = new URLSearchParams();
            params.append("term", e.target.value);
            axios.post(
                userData["api-base-url"] ? userData["api-base-url"] + "modules/api/auth_users/autocomplete" : "https://app4legaladd.azurewebsites.net/" + "modules/api/auth_users/autocomplete", params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    "x-api-key": userData["x-api-key"],
                    "x-api-channel": "zoom-connect"
                }
            }).then((res) => {
                if (res.data.error == "") {
                    setLookUpData(res.data.success.data);
                    setLoading(false);
                }
            });
        }
        else {
            setLookUpData([]);
            setLoading(false);
        }
        //).then((res) => {
        //    console.log(res);
        //});
        setFoundUsers(props.items);
        const keyword = e.target.value;
        if (keyword !== '') {
            setSelectAll(false);
            const results = props.items?.filter((user: any) => {
                return user.fullName?.toLowerCase()?.startsWith(keyword?.toLowerCase()) || user.email?.toLowerCase()?.startsWith(keyword?.toLowerCase());
                // Use the toLowerCase() method to make it case-insensitive
            });
            if (results?.length > 0)
                setFoundUsers(results);
            else
                setFoundUsers(null);
        } else {
            setSelectAll(true);
            setFoundUsers(props.items);
            // If the text field is empty, show all users
        }
        setName(keyword);
    };
    const [searchTerm, setSearchTerm] = React.useState("");
    const [searchResults, setSearchResults] = React.useState([]);
    const handleChange = (event: any) => {
        setSearchTerm(event.target.value);
    };
    React.useEffect(() => {
        if (!props.invite) {
        }
    }, [checked]);
    React.useEffect(() => {
        const results = props?.items?.filter((deivce: any) => {
            return deivce?.fullName?.toLowerCase().startsWith(searchTerm?.toLowerCase());
        });
        setSearchResults(results);
    }, [searchTerm]);
    const selectItem = (e: any | null) => {
        const { checked } = e.target;
        if (checked) {
            //add();
            setChecked(checkDefault)
        } else {
            setChecked([]);
        }
        setItemsChecked(checked);
    };
    const handleClickInviteAll = async () => {
        setLoadButton(true);
        var test: any = {
            start: [moment().year(), moment().month() + 1, moment().date(), moment().hour(), moment().minute()],
            duration: { hours: 1, minutes: 0 },
            title: zoomMeetingData.topic ?? "App4Legal Zoom Meeting Invitation",
            description: "Invitation to Zoom Meeting",
            status: "CONFIRMED",
            busyStatus: "BUSY",
            organizer: { name: userData.profileName, email: userData.email },
        }

        let emails = [];
        for (var i = 0; i < props.items.length; i++) {
            let result = checked?.find((element: any) => element == props.items[i].id);

            if (result || result === 0) {
                if (props.items[i].email != "") {
                    emails.push(props.items[i].email);

                }
            }
        }
        let formData = new FormData();
        createEvent(test, (error, value) => {
            const blob: any = new Blob([value], { type: "text/plain;charset=utf-8" });
            let file = new File([blob], "invite.ics", { type: "text/json;charset=utf-8" });
            formData.append("attachments[0]", file);
            //saveAs(blob, "event-schedule.ics");
        });
        if (emails.length > 0) {
            emails.map((email, index) => {
                formData.append("to[" + index + "]", email);
            });
            //parameters.append("to[0]", emails);
            formData.append("cc[]", "");
            formData.append("subject", "Invitation to Zoom Meeting");
            formData.append("body", "<h5>" + i18n.t('app.youHaveBeenInvitedToJoin') + "</h4><div style=\"background-color:#A3EBB1;padding:10px;width:50%;\">" + zoomMeetingData.topic + " on " + moment(zoomMeetingData.datePickerValue).format("MMM DD, YY") + "  " + zoomMeetingData.timezone.split("/")[0] + "<br/></div><br/>" + i18n.t('app.useThisLinkToJoinTheMeeting') + "<br/> <a href=\"" + zoomMeetingData.join_url + "\">" + zoomMeetingData.join_url + "</a></h5>");

            let sendEmailsResponse = await axios.post(
                userData["api-base-url"] ? userData["api-base-url"] + "modules/api/custom_email/send_notification" : "https://app4legaladd.azurewebsites.net/" + "modules/api/email/send_notification", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "x-api-key": userData["x-api-key"],
                    "x-api-channel": "mobile"
                }
            }
            );
            if ((sendEmailsResponse)?.data.error == "") {
                if (props.invite)
                    props.handleParticipantsClosee("success", "invitation has been sent successfully");
                store.dispatch(ModalStore.actionCreators.openModalSuccess(i18n.t('app.theMeetingSchedulehasbeensetSuccessfully')))

            }
            else {
                if (props.invite)
                    props.handleParticipantsClosee("error", JSON.stringify(sendEmailsResponse?.data.error));
                // store.dispatch(ModalStore.actionCreators.openModalError(JSON.stringify(sendEmailsResponse?.data.error)))
                setLoadButton(false);
            };
        }
        else {
            props.handleParticipantsClosee("error", i18n.t('app.youNeedToChooseAtLeastOneInvitee'));
            // store.dispatch(ModalStore.actionCreators.openModalError("you need to choose at least 1 invitee"));
            setLoadButton(false);
        }
        if (!props.invite) {
            props?.fillEmailsData(emails);
            props?.getEmails(emails, emailBody, checked);
        }

    };
    const handleChangeCheckBox = (value: number) => {
        if (checked?.indexOf(value) === -1) {
            setChecked([...checked, value]);
        }
        else {
            let filteredArray = checked?.filter((e: number) => e !== value)
            setItemsChecked(false);
            setChecked(filteredArray);
        }
        props.parentCallback(checked?.length);
        let emails = "";
        let usersId = [];
        for (var i = 0; i < props.items.length; i++) {
            let result = checked?.find((element: any) => element == props.items[i].id);
            if (result || result === 0) {
                if (props.items[i].email)
                    emails = emails + props.items[i].email + ",";
            }
            usersId.push(props.items[i].id);
        }
        setInvitedEmails(emails);
        if (!props.invite) {
            props?.fillEmailsData(emails);
            props?.getEmails(emails, emailBody, checked);
        }
    };
    if (!props.invite) {
        props?.getEmails(invitedEmails, emailBody, checked);
    }
    props?.parentCallback(checked?.length);
    return (
        <div style={{ paddingTop: '10px' }}>
            <TextField
                placeholder={i18n.t('app.search')}

                value={name}
                onChange={(e) => { filter(e); }}
                size="small"
                sx={{ paddingLeft: '10px', paddingRight: '15px', paddingBottom: '10px', }}
                fullWidth
                // variant="standard"
                InputProps={{
                    endAdornment: (
                        <React.Fragment>
                            {loading ? <CircularProgress color="inherit" size={20} /> : <></>}

                        </React.Fragment>
                    ),
                    disableUnderline: true,
                }}
            />
            <br></br>
            {module ? foundUsers && foundUsers.length > 0 ? selectAll ? <>
                <Checkbox checked={itemsChecked} onClick={selectItem} /><b> {i18n.t('app.selectAll')} </b>
                <Divider variant="middle" component="li" /></>
                : null : null : null}
            {lookupData && lookupData.length > 0 ? <>
                {lookupData.map((item: any, index: number) => (<ListItem>
                    <ListItemText
                        primary={item.firstName + " " + item.lastName}
                        secondary={
                            <React.Fragment>
                            </React.Fragment>
                        }
                    />
                    <ListItemIcon sx={{ minWidth: "35px" }}>
                        <Button onClick={(event) => {
                            // props.items.unshift({ email: item.email, fullName: item.firstName + " " + item.lastName, id: item.id });
                            setSelectAll(true);
                            let obj = props.items?.find((o: any) => /*o?.id === item?.id &&*/ o?.email == item?.email);
                            setName("");
                            if (!obj) {
                                if (props?.items?.length !== 0)
                                    props?.items?.unshift({ email: item.email, fullName: item.firstName + " " + item.lastName, id: item.id });
                                else {
                                    props?.items?.push({ email: item.email, fullName: item.firstName + " " + item.lastName, id: item.id });
                                }
                            }
                            setFoundUsers(props.items);
                            setLookUpData([]);
                            handleChangeCheckBox(item.id);
                            addNew();
                            //add();
                        }}
                            variant="contained"
                            color="primary"
                            size="medium"
                        >ADD</Button>
                    </ListItemIcon>
                </ListItem>))}
            </>
                : foundUsers && foundUsers.length > 0 ? (
                    foundUsers.map((item: any, index: number) => (
                        <>
                            <ListItem onClick={(event) => handleChangeCheckBox(item.id)}>
                                <ListItemIcon sx={{ minWidth: "35px" }}>
                                    <Checkbox
                                        edge="start"
                                        checked={checked?.indexOf(item.id) !== -1}
                                        size="small"
                                        tabIndex={item.id}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': item.fullName }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.fullName}
                                    secondary={
                                        <React.Fragment>
                                            {item.type}
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                            <Divider variant="middle" component="li" /></>
                    ))
                )
                    : Helpers.ValidateEmail(name) ? <>
                        <ListItem>
                            <ListItemText
                                primary={name}
                                secondary={
                                    <React.Fragment>
                                    </React.Fragment>
                                }
                            />
                            <ListItemIcon sx={{ minWidth: "35px" }}>
                                <Button onClick={(event) => {
                                    props.items.unshift({ email: name, fullName: name, id: props.items.length });
                                    setSelectAll(true);
                                    setFoundUsers(props.items);
                                    setName("");
                                    handleChangeCheckBox(props.items.length - 1);
                                    addNew();
                                }}
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                >ADD Email</Button>
                            </ListItemIcon>
                        </ListItem>
                    </> : <></>}
            {props.invite ? foundUsers && foundUsers.length > 0 ? <>
                <AppBar position="sticky" color="inherit" sx={{ top: 'auto', bottom: 0 }} elevation={0}>
                    <Toolbar sx={{ marginLeft: "auto" }}>
                        <LoadingButton
                            loading={loadButton}
                            loadingPosition="start"
                            startIcon={<RsvpIcon />}
                            type="submit"
                            form="addClause"
                            variant="contained"
                            color="primary"
                            size="medium"
                            onClick={handleClickInviteAll} >
                            {i18n.t('app.invite')}
                        </LoadingButton>
                    </Toolbar>
                </AppBar>
            </> : <></> : <></>}
        </div>
    );
}
export default connect(null, { ...AppDataStore.actionCreators })(SearchBar);
